import { render, staticRenderFns } from "./solicitacoesEnviadas.vue?vue&type=template&id=74fc8597&scoped=true&"
import script from "./solicitacoesEnviadas.vue?vue&type=script&lang=js&"
export * from "./solicitacoesEnviadas.vue?vue&type=script&lang=js&"
import style0 from "./solicitacoesEnviadas.vue?vue&type=style&index=0&id=74fc8597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc8597",
  null
  
)

export default component.exports